module.exports = __webpack_public_path__ + "static/img/golden-transformers.e76973e5.jpg";